import { SimAtomic } from "../simstance/SimAtomic.js";
import { getInjection } from "../decorators/inject/Injection.js";
import { MethodNoSuch } from "../throwable/MethodNoSuch.js";
import { getRouter } from "../decorators/route/Router.js";
import { Expression } from "@dooboostore/core";
class RouterModule {
  constructor(simstanceManager, router, module, routerChains = []) {
    this.simstanceManager = simstanceManager;
    this.router = router;
    this.module = module;
    this.routerChains = routerChains;
  }
  get path() {
    return this._path;
  }
  set path(value) {
    this._path = value;
  }
  get data() {
    return this._data;
  }
  set data(value) {
    this._data = value;
  }
  get intent() {
    return this._intent;
  }
  set intent(value) {
    this._intent = value;
  }
  get propertyKeys() {
    return this._propertyKeys;
  }
  set propertyKeys(value) {
    this._propertyKeys = value;
  }
  get pathData() {
    return this._pathData;
  }
  getPathData() {
    return this._pathData;
  }
  set pathData(value) {
    this._pathData = value;
  }
  getRouterPath(join = "") {
    return this.getRouterPaths().map((it) => it ?? "").join(join);
  }
  getRouterPaths() {
    return this.routerChains.map((it) => getRouter(it instanceof SimAtomic ? it.type.targetKeyType : it)?.path);
  }
  getRouterPathData(pathName) {
    return Expression.Path.pathNameData(pathName, this.getRouterPath());
  }
  getModuleInstance(propertyKey, instanceBind = true) {
    const instance = this.simstanceManager.getOrNewSim({ target: this.module?.targetKeyType, originTypeTarget: this.module?.originalType });
    if (propertyKey && this.propertyKeys && this.propertyKeys.includes(propertyKey)) {
      let instanceElement = instance[propertyKey];
      if (instanceBind && typeof instanceBind === "boolean") {
        instanceElement = instanceElement.bind(instance);
      } else if (instanceBind && typeof instanceBind === "object") {
        instanceElement = instanceElement.bind(instanceBind);
      }
      return instanceElement;
    } else {
      return instance;
    }
  }
  executeModuleProperty(propertyKey, ...param) {
    const target = this.getModuleInstance();
    if (propertyKey) {
      const config = getInjection(target, propertyKey);
      if (config) {
        const other = /* @__PURE__ */ new Map();
        param.forEach((it) => other.set(it.constructor, it));
        return this.simstanceManager.executeBindParameterSim({ target, targetKey: propertyKey }, other);
      } else {
        if (target[propertyKey]) {
          return target[propertyKey]?.(...param);
        } else {
          throw new MethodNoSuch(`${propertyKey.toString()} noSuch`, propertyKey.toString(), propertyKey);
        }
      }
    }
  }
  get firstRouteChain() {
    return this.routerChains[0];
  }
  get firstRouteChainValue() {
    return this.firstRouteChain?.getValue();
  }
  get lastRouteChain() {
    return this.routerChains[this.routerChains.length - 1];
  }
  get lastRouteChainValue() {
    return this.lastRouteChain?.getValue();
  }
  hasActivateInLastRoute(obj) {
    return this.lastRouteChainValue?.hasActivate(obj) === true;
  }
  getQueryParamDecodeURI(key) {
    if (this.intent) {
      return this.intent.getQueryParamDecodeURI(key);
    }
  }
  getQueryParamDecodeURIFirst(key) {
    if (this.intent) {
      return this.intent.getQueryParamDecodeURIFirst(key);
    }
  }
  getQueryParam(key) {
    if (this.intent) {
      return this.intent.getQueryParam(key);
    }
  }
  getQueryParamFirst(key) {
    if (this.intent) {
      return this.intent.getQueryParamFirst(key);
    }
  }
  get queryParams() {
    if (this.intent) {
      return this.intent.queryParams;
    }
  }
  get queryParamsAfterDecodeURI() {
    if (this.intent) {
      return this.intent.queryParamsDecodeURI;
    }
  }
}
export {
  RouterModule
};
//# sourceMappingURL=RouterModule.js.map
